import { CircularProgress } from "@mui/material";
import { FC } from "react";
import { COLOR_WHITE } from "shared/theme/colors";
import { ReplayIcon } from "shared/theme/icons/ReplayIcon";
import { StyledRefreshButton } from "./styled";

type RefreshButtonProps = {
  isLoading: boolean;
  handleClick: (e: React.MouseEvent<HTMLElement>) => void;
};

const RefreshButton: FC<RefreshButtonProps> = ({ isLoading, handleClick }) => {
  return (
    <>
      {isLoading ? (
        <CircularProgress sx={{ color: COLOR_WHITE }} size={16} />
      ) : (
        <StyledRefreshButton onClick={handleClick}>
          <ReplayIcon />
        </StyledRefreshButton>
      )}
    </>
  );
};

export default RefreshButton;
